export default {
  contracts: {
    activeContracts: 'Active contracts',
    productsAndHours: 'Covered products and remaining support hours',
    supported: 'Supported',
    notSupported: 'Not supported',
    contact: 'Manager',
    dividerText: 'COVERED PRODUCTS AND REMAINING SUPPORT HOURS'
  },
  states: {
    OPEN: 'Open',
    AWAITING_REPLY: 'Awaiting reply',
    CLOSED: 'Closed',
    FEEDBACK_REQUIRED: 'Feedback required',
    onlyRequired: 'Show only required action',
    onlyWorkRequests: 'Show only Work Requests for approval'
  },
  common: {
    New: 'New',
    Open: 'Open',
    Pending: 'Pending',
    Closed: 'Closed',
    create: 'Create',
    cancel: 'Cancel',
    goBack: 'Go back',
    close: 'Close',
    goToMain: 'Go to main page',
    news: 'News Feed',
    moreInfo: 'More information',
    change: 'change',
    send: 'Send',
    description: 'Description',
    skip: 'Skip'
  },
  property: {
    name: 'Property',
    allProperties: 'All properties',
    selectProperty: 'Select property'
  },
  product: {
    name: 'Product',
    allProducts: 'All products',
    selectProduct: 'Select product',
    goBack: 'Go back',
    noProducts: 'No products'
  },
  chart: {
    chooseMonth: 'Choose month',
    noData: 'There is no data for current period'
  },
  navigation: {
    main: 'MAIN',
    interactions: 'TICKETS',
    contracts: 'CONTRACTS',
    signOut: 'SIGN OUT'
  },
  tickets: {
    createNewTitle: 'Create new ticket',
    title: 'Title',
    noTickets: 'There is no tickets with current filters preset',
    search: 'Search',
    createNew: 'Create new',
    reopenOrDisagree: 'Disagree',
    escalation: 'Escalate',
    reason: 'Reason',
    reopen: 'Reopen',
    disagree: 'Disagree',
    escalate: 'Escalate',
    opinionTitle: 'Your opinion is important for us!',
    opinionBody: 'Please rate our support staff work',
    time: 'Resolution time',
    qualification: 'Technical qualification',
    communication: 'Communication skills',
    sendFeedback: 'Send feedback',
    leaveFeedback: 'Leave feedback',
    close: 'Close',
    alreadyHasFeedback: 'Ticket already has feedback',
    feedbackHasBeenSent: 'Feedback has been sent',
    ticketHasBeenReopened: 'Ticket has been reopened',
    ticketHasBeenEscalated: 'Ticket has been escalated',
    comment: 'Comment',
    keyPlaceholder: 'Type message',
    approve: 'Approve',
    reject: 'Reject',
    workRequestOnContractNotification:
      'Dear {{fullName}},\n\nCurrently, you have {{hoursInSupportContract}} hours of value-added services included in your support contract.\nThe ticket {{workRequestId}} will require {{hoursRequested}} hours to complete.\n\nPlease, approve deducting the hours from the balance for the above task.\nThank you\n\nRegards,\n{{author}}',
    workRequestChargeableNotification:
      'Dear {{fullName}},\n\nThis work is not included in the service or guaranteed under the contract. We will be happy to schedule and assist. We estimate {{hoursRequested}} hours to complete the request {{workRequestId}}.\n\nThe cost of completing this request will be {{amount}}.\nThis offer is valid within 7 days from the date of the issue.\nIf the actual time spent exceeds the original quote, then an additional request form for extra hours will be sent to the requestor for approval.If the estimated time is less than the original quote, the original quote will be cancelled and a revised quote will be sent.\n\nPlease, approve the additional work and charge.\n\nRegards,\n{{author}}',
    workRequestCommentRequired:
      'Please provide a reason for rejecting job request.'
  },
  severity: {
    name: 'Severity',
    0: 'Normal',
    1: 'High',
    2: 'Critical',
    wantToChange: 'Want to change severity?'
  },
  forms: {
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    passwordsDoNotMatch: 'Passwords do not match',
    updatePassword: 'Update password',
    askRestore: 'Ask for password update',
    remember: 'Remember me',
    restorePassword: 'Forgot password?',
    signIn: 'Sign In',
    required: 'Required',
    invalidEmail: 'Invalid email address'
  },
  transactions: {
    date: 'Date',
    type: 'Type',
    comment: 'Comment',
    status: 'Status',
    subject: 'Work Request',
    name: 'Transactions List',
    hours: 'Hours',
    viewTransactions: 'View transactions',
    types: {
      WORK_REQUEST: 'Work request',
      CONTRACT_ACTIVATION: 'Contract activation',
      CONTRACT_EXPIRATION: 'Contract expiration',
      MANUAL_ADJUST_ADD: 'Manual adjustment - add',
      MANUAL_ADJUST_DEDUCT: 'Manual adjustment - deduct',
      TRANSFER_PROPERTY: 'Property transfer',
      TRANSFER_PRODUCT: 'Product transfer'
    }
  },
  transactionDetail: {
    name: 'Transaction Detail',
    num: 'Number',
    insertTime: 'Creation date',
    requestorName: 'Requestor name',
    subject: 'Subject',
    status: 'Status',
    acceptTime: 'Accept date',
    cancelTime: 'Cancel date',
    hours: 'Hours',
    hourType: 'Hours type',
    workText: 'Work description',
    plannedDate: 'Planned date'
  },
  statuses: {
    Approved: 'Approved',
    Pending: 'Pending',
    Cancelled: 'Cancelled'
  },
  hoursTypes: {
    'Included in contract': 'Included in contract',
    'Installation hours': 'Installation hours',
    'Preventative visit': 'Preventative visit',
    Chargeable: 'Chargeable'
  },
  errors: {
    unknown: 'Unknown error',
    1000: 'Request error',
    1001: 'Request error',
    1: 'Incorrect login or password',
    2: 'Session expired',
    3: 'Unknown property',
    4: 'Unknown product',
    7: 'Unknown ticket',
    8: 'Ticket is already closed',
    11: 'Access violation',
    12: 'Unknown workrequest',
    660: 'The ticket can not be closed at the moment, as it contains unprocessed applications for work. Support has received your closing request. Thank you.',
    fileSize: "You can't upload files more than 20 mb"
  },
  phrases: {
    noAccount: ["Don't have an account?", 'Contact us'],
    dnd: ['Drag files here or', 'Drop files here or', 'browse']
  }
}
